import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useRef } from 'react';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import axios from 'axios';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  CssBaseline,
  useMediaQuery,
  createTheme,
  ThemeProvider,
  Alert, Stack, Button, Dialog, DialogContent
} from '@mui/material';
import { Support, Chat } from '@mui/icons-material';


import HomeIcon from '@mui/icons-material/Home';
import WalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ReceiptIcon from '@mui/icons-material/Receipt';
import logo from '../../assets/xpdlogo.png';
import emailIcon from '../../assets/email-icon.png';
import Header from './Header'; // Import the Header component
// import { Chat } from '@mui/icons-material';

const drawerWidth = 250;
const propertyId = "66ffc61a256fb1049b1ce474" // Replace with your propertyId
const widgetId = "1i9bhrm3m"     // Replace with your widgetId

const theme = createTheme({
  typography: {
    fontFamily: "Inter, Arial, sans-serif",
  },
  palette: {
    primary: {
      main: '#542a74',
    },
  },
});

const UserLayout = () => {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const isDesktop = useMediaQuery('(min-width:1000px)');
  const username = Cookies.get('title') || 'User';
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // const handleLogout = () => {
  //   Cookies.remove('token');
  //   Cookies.remove('role');
  //   navigate('/login');
  // };

  // Secure logout function
  const handleLogout = async () => {
    try {
      const token = Cookies.get('token');

      if (token) {
        // Call logout API
        // await axios.post('/api/logout', {}, {
        //   headers: { Authorization: `Bearer ${token}` }
        // });

        // Clear all storage and cookies
        Cookies.remove('token');
        Cookies.remove('role');
        Cookies.remove('userId');
        Cookies.remove('title');
        Cookies.remove('email');
        Cookies.remove('userStatus');
        Cookies.remove('kycStatus');
        sessionStorage.clear();
        localStorage.clear();

        // Clear cookies
        document.cookie.split(";").forEach(cookie => {
          document.cookie = cookie
            .replace(/^ +/, "")
            .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        });

        // Prevent back navigation
        window.history.pushState(null, '', '/login');
        window.history.replaceState(null, '', '/login');

        // Redirect to login
        navigate('/login', { replace: true });
      }
    } catch (error) {
      console.error('Logout error:', error);
      // Still clear storage and redirect even if API call fails
      Cookies.remove('token');
      Cookies.remove('role');
      Cookies.remove('userId');
      Cookies.remove('title');
      Cookies.remove('email');
      Cookies.remove('userStatus');
      Cookies.remove('kycStatus');
      sessionStorage.clear();
      localStorage.clear();
      navigate('/login', { replace: true });
    }
  };
  // Protect routes and prevent automatic logout
  useEffect(() => { 
    // Check for token on mount
    const token = Cookies.get('token');
    if (!token) {
      navigate('/login', { replace: true });
      return;
    }

    // Prevent back button
    window.history.pushState(null, '', window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
    };
    window.addEventListener('popstate', handlePopState);

    // Add axios interceptor for 401 responses
    const interceptor = axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response?.status === 401) {
          handleLogout();
        }
        return Promise.reject(error);
      }
    );

    // Cleanup
    return () => {
      window.removeEventListener('popstate', handlePopState);
      axios.interceptors.response.eject(interceptor);
    };
  }, []);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const tawkMessengerRef = useRef();
  const [isChatOpen, setIsChatOpen] = useState(false);

  const handleChatToggle = () => {
    if (window.Tawk_API) {
      if (isChatOpen) {
        window.Tawk_API.minimize();
        setIsChatOpen(false);
      } else {
        window.Tawk_API.maximize();
        setIsChatOpen(true);
      }
    }
  };
  //   const handleMinimize = () => {
  //     tawkMessengerRef.current.minimize();
  // };
  // Function to handle chat window visibility
  // const handleChatToggle = () => {
  //   if (tawkMessengerRef.current) {
  //     const isVisible = tawkMessengerRef.current.getWindowType() !== 'min';
  //     if (isVisible) {
  //       tawkMessengerRef.current.minimize();
  //     } else {
  //       tawkMessengerRef.current.maximize();
  //     }
  //   }
  // };

  // // Function to handle when tawk.to is loaded
  // const handleLoad = () => {
  //   // Get user data from your session/storage
  //   const userData = {
  //     name: Cookies.get('title') || 'Guest',
  //     email: Cookies.get('email') || '',
  //     id: Cookies.get('userId') || '',
  //   };

  //   // Set visitor attributes when chat loads
  //   if (window.Tawk_API) {
  //     window.Tawk_API.setAttributes({
  //       name: userData.name,
  //       email: userData.email,
  //       id: userData.id
  //     }, (error) => {
  //       if (error) {
  //         console.error('Error setting Tawk.to user details:', error);
  //       }
  //     });
  //   }
  // };
  const location = useLocation();

  const userStatus = Cookies.get('userStatus') || 'unknown';
  const kycStatus = Cookies.get('kycStatus') || 'unknown';

  const drawerContent = (
    <Box
      sx={{
        width: drawerWidth,
        marginTop: { xs: 0, md: "64px" }, // Adjust margin for mobile
        overflowX: "hidden",
        height: "100%", // Add this
        display: "flex", // Add this
        flexDirection: "column", // Add this
      }}
    >
      {/* Add mobile header for drawer */}
      {!isDesktop && (
        <Box
          sx={{
            height: 64,
            display: 'flex',
            alignItems: 'center',
            px: 2,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          }}
        >
          <img
            src={logo}
            alt="My XPD"
            style={{ height: '40px' }}
          />
        </Box>
      )}
      <Divider />
      <List sx={{ padding: 2, flex: 1 }}> {/* Add flex: 1 */}
        {[
          { text: "Dashboard", icon: <HomeIcon />, path: "/dashboard" },
          { text: "Wallets", icon: <WalletIcon />, path: "/wallets" },
          { text: "Cards", icon: <CreditCardIcon />, path: "/cards" },
          { text: "Transactions", icon: <ReceiptIcon />, path: "/transactions" },
        ].map((item) => (
          <ListItem
            button
            key={item.text}
            component={Link}
            to={item.path}
            sx={{
              borderRadius: 4,
              marginBottom: 0.5,
              backgroundColor:
                location.pathname === item.path ? "#e8f0fc" : "transparent",
              color: location.pathname === item.path ? "#542a74" : "#542a74",
              "&:hover": {
                backgroundColor: location.pathname === item.path
                  ? "#e8f0fc"
                  : "transparent",
              },
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: "28px",
                marginRight: "8px",
                marginLeft: "8px",
                color: location.pathname === item.path ? "#542a74" : "#542a74",
              }}
            >
              {item.icon}
            </ListItemIcon>
            <ListItemText
              primary={item.text}
              primaryTypographyProps={{
                fontSize: "14px",
                fontWeight: 'medium',
                color: location.pathname === item.path ? "#542a74" : "#542a74",
              }}
            />
          </ListItem>
        ))}
      </List>
      {/* <Divider /> */}

      {/* Support Buttons */}
      <Box sx={{ p: 2, mt: 'auto', mb: 5 }}> {/* Add support buttons container */}
        <Stack spacing={1}>


          <Button
            fullWidth
            startIcon={<Chat />}
            onClick={handleChatToggle}
            sx={{
              justifyContent: 'flex-start',
              color: '#542a74',
              backgroundColor: 'transparent',
              p: 1,
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 'medium',
            }}
          >
            Live Chat
          </Button>
          {/* <TawkMessengerReact
            propertyId={propertyId}
            widgetId={widgetId}
            ref={tawkMessengerRef}
            onLoad={handleLoad}
            customStyle={{
              visibility: {
                desktop: {
                  position: 'fixed',
                  bottom: '20px',
                  right: '20px'
                },
                mobile: {
                  position: 'fixed',
                  bottom: '0',
                  right: '0',
                  left: '0'
                }
              },
              zIndex: 1000
            }}
          /> */}
          <Button
            fullWidth
            startIcon={<Support />}
            onClick={handleOpen}
            sx={{
              justifyContent: 'flex-start',
              color: '#542a74',
              backgroundColor: 'transparent',
              p: 1,
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 'medium',
            }}
          >
            Support Email
          </Button>
        </Stack>
      </Box>
    </Box>
  );

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <CssBaseline />

        {/* Header */}
        <Header
          username={username}
          onLogout={handleLogout}
          isDesktop={isDesktop}
          drawerWidth={drawerWidth}
          handleDrawerToggle={handleDrawerToggle} // Add this
        />

        {/* Drawer */}
        {isDesktop ? (
          <Drawer
            variant="permanent"
            sx={{
              width: drawerWidth,
              height: 'calc(100vh - 64px)',
              flexShrink: 0,
              [`& .MuiDrawer-paper`]: {
                width: drawerWidth,
                boxSizing: 'border-box',
                border: 'none',
                boxShadow: 'none',
              },
            }}
          >
            {drawerContent}
          </Drawer>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: 'block', md: 'none' },
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
                border: 'none',
                boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)',
              },
            }}
          >
            {drawerContent}
          </Drawer>
        )}

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: {
              xs: 0,     // 0 padding for mobile
              sm: 2,     // 16px padding for tablet
              md: 3      // 24px padding for desktop
            },
            mt: 8,
            backgroundColor: '#f6f6f9',
            width: '100%',
            overflowX: 'hidden',
            mb: 8, // Add margin bottom to avoid overlap with the alert
            minHeight: 'calc(100vh - 64px - 56px)', // Adjust for header and alert height
          }}
        >
          {/* //should be open on clicking on live chat button */}
          <Box sx={{ display: 'none' }}>
            <TawkMessengerReact
              propertyId="66ffc61a256fb1049b1ce474"
              widgetId="1i9bhrm3m"
              ref={tawkMessengerRef} />
          </Box>


          {/* Alerts based on KYC and User Status */}
          {kycStatus === 'pending' || kycStatus === 'rejected' || kycStatus === 'unknown' || !kycStatus || kycStatus === 'null' ? (
            <Alert
              severity="warning"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#fff3cd',
                color: '#856404',
                mx: 3,
                borderRadius: 4,
              }}
            >
              Your verification is pending. Please{' '}
              <Link to="/kyc-verify" style={{ marginLeft: 4, color: '#542a74', textDecoration: 'underline' }}>
                click here to verify
              </Link>
              .
            </Alert>
          ) : kycStatus === 'processing' ? (
            <Alert
              severity="info"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#d1ecf1',
                color: '#0c5460',
                mx: 3,
                borderRadius: 4,
              }}
            >
              We are currently verifying your data. Please{' '}
              <Link to="/kyc-verify" style={{ marginLeft: 4, color: '#542a74', textDecoration: 'underline' }}>
                click here to check status
              </Link>
            </Alert>
          ) : kycStatus === 'verified' ? (
            userStatus === 'inactive' || userStatus === 'suspended' || userStatus === 'registered' || userStatus === 'unknown' || !userStatus || userStatus === 'null' ? (
              <Alert
                severity="error"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#f8d7da',
                  color: '#721c24',
                  mx: 3,
                  borderRadius: 4,
                }}
              >
                Your account is not active. Please contact support.
              </Alert>
            ) : null
          ) : null}

          <Outlet />
        </Box>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)',
            margin: 2
          }
        }}
      >
        <DialogContent>
          <div
            style={{
              backgroundColor: 'rgb(246, 239, 255)',
              padding: '36px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              borderRadius: '8px'
            }}
          >
            {/* Title */}
            <p style={{
              fontSize: '24px',
              fontWeight: 600,
              color: 'black',
              margin: 0
            }}>
              Support Email
            </p>

            {/* Email Icon */}
            <div style={{
              width: '120px',
              height: '120px',
              backgroundColor: '#F5FAFF',
              borderRadius: '50%',
              marginTop: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden'
            }}>
              <img
                src={emailIcon}
                alt="Email"
                style={{
                  width: '80%',
                  height: '80%',
                  objectFit: 'cover'
                }}
              />
            </div>

            {/* Email Address */}
            <a
              href="mailto:support@myxpd.app"
              style={{
                marginTop: '40px',
                color: 'rgb(143, 39, 199)',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: 400
              }}
            >
              support@myxpd.app
            </a>
          </div>
        </DialogContent>
      </Dialog>
    </ThemeProvider>
  );
};

export default UserLayout;